import { Component, OnInit } from '@angular/core';

export interface SggsTableElement {
  c0: string;
  c1: string;
  c2: string;
  c3: string;
  c4: string;
  c5: string;
}
export interface SggsConsonantsTableElement {
  id: number;
  vowels: string;
  a: string;
  b: string;
  c: string;
  d: string;
  e: string;
  f: string;
  g: string;
  h: string;
  i: string;
  j: string;
}

export interface SggsSubscriptsTableElement {
  subscript: string;
  origin: string;
  example: string;
  transcription: string;
}

export interface SggsCardinalsTableElement {
  roman: string;
  a: string;
  b: string;
  c: string;
  d: string;
  e: string;
  f: string;
  g: string;
  h: string;
  i: string;
  j: string;
}

const ELEMENT_DATA: SggsTableElement[] = [
  {
    c0: 'R1',
    c1: 'Vowels',
    c2: ' ',
    c3: ' ',
    c4: 'ਸ (s)',
    c5: 'ਙ (ṅ)',
  },
  {
    c0: ' ',
    c1: 'ੳ (-)',
    c2: 'ਅ (a)',
    c3: 'ੲ (-)',
    c4: ' ',
    c5: ' ',
  },
  {
    c0: 'R2',
    c1: 'ਕ (k)',
    c2: 'ਖ (kh)',
    c3: 'ਗ (g)',
    c4: 'ਘ (gh)',
    c5: 'ਙ (ṅ)',
  },
  {
    c0: 'R3',
    c1: 'ਚ (c)',
    c2: 'ਛ (ch)',
    c3: 'ਜ (j)',
    c4: 'ਝ (jh)	',
    c5: 'ਞ (ñ)',
  },
  {
    c0: 'R4',
    c1: 'ਟ (ṭ)',
    c2: 'ਠ (ṭh)',
    c3: 'ਡ (ḍ)',
    c4: 'ਢ (ḍh)	',
    c5: 'ਣ (ṇ)',
  },
  {
    c0: 'R5',
    c1: 'ਤ (t)',
    c2: 'ਥ (th)',
    c3: 'ਦ (d)',
    c4: 'ਧ (dh)	',
    c5: 'ਨ (n)',
  },
  {
    c0: 'R6',
    c1: 'ਪ (p)',
    c2: 'ਫ (ph)',
    c3: 'ਬ (b)',
    c4: 'ਭ (bh)	',
    c5: 'ਮ (m)',
  },
  {
    c0: 'R7',
    c1: 'ਯ (y)',
    c2: 'ਰ (r)',
    c3: 'ਲ (l)',
    c4: 'ਵ (v)	',
    c5: 'ੜ (ṛ)',
  },
  {
    c0: 'Gurmukhi Consonants',
    c1: ' ',
    c2: ' ',
    c3: ' ',
    c4: '	',
    c5: ' ',
  },
];
const CONSONANTS_ELEMENT_DATA: SggsConsonantsTableElement[] = [
  {
    id: 1,
    vowels: 'Transcription',
    a: 'a',
    b: 'ā',
    c: 'i',
    d: 'ī',
    e: 'u',
    f: 'ū',
    g: 'e',
    h: 'ai',
    i: 'o',
    j: 'au',
  },
  {
    id: 2,
    vowels: 'Gurmukhi Vowels',
    a: ' ',
    b: ' ',
    c: ' ',
    d: ' ',
    e: ' ',
    f: ' ',
    g: ' ',
    h: ' ',
    i: ' ',
    j: ' ',
  },
];

const SUBSCRIPTS_ELEMENT_DATA: SggsSubscriptsTableElement[] = [
  {
    subscript: 'ਕ (k)',
    origin: 'ਕ (k)',
    example: 'ਕ (k)',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਕ (k)',
    example: 'ਕ (k)',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਟ',
    example: 'ਬਿਸ੍ਹਾ',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਤ',
    example: 'ਅਸੂ',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਨ',
    example: 'ਕ੍ਸ੍ਹ',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਯ',
    example: 'ਦੁਖ੍',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਰ',
    example: 'ਪ੍ਰਾਈ',
    transcription: 'ਕ (k)',
  },
  {
    subscript: 'ਕ (k)',
    origin: 'ਵ',
    example: 'ਜਗਦੀਸੂਰਹ',
    transcription: 'ਕ (k)',
  },
];

const CARDINALS_ELEMENT_DATA: SggsCardinalsTableElement[] = [
  {
    roman: 'Gurmukhi',
    a: '੦',
    b: '੧',
    c: '੨',
    d: '੩',
    e: '੪',
    f: '੫',
    g: '੬',
    h: '੭',
    i: '੮',
    j: '੯',
  },
];

@Component({
  selector: 'app-transcription-guidelines',
  templateUrl: './transcription-guidelines.component.html',
  styleUrls: ['./transcription-guidelines.component.scss'],
})
export class TranscriptionGuidelinesComponent implements OnInit {
  isHandsetPortrait: boolean = false;
  columns = [
    {
      columnDef: 'c0',
      header: ' ',
      cell: (element: SggsTableElement) => `${element.c0}`,
    },
    {
      columnDef: 'c1',
      header: 'C1',
      cell: (element: SggsTableElement) => `${element.c1}`,
    },
    {
      columnDef: 'c2',
      header: 'C2',
      cell: (element: SggsTableElement) => `${element.c2}`,
    },
    {
      columnDef: 'c3',
      header: 'C3',
      cell: (element: SggsTableElement) => `${element.c3}`,
    },
    {
      columnDef: 'c4',
      header: 'C4',
      cell: (element: SggsTableElement) => `${element.c4}`,
    },
    {
      columnDef: 'c5',
      header: 'C5',
      cell: (element: SggsTableElement) => `${element.c5}`,
    },
  ];
  consonantsColumns = [
    {
      columnDef: 'vowels',
      header: 'Vowels ',
      cell: (element: SggsConsonantsTableElement) => `${element.vowels}`,
    },
    {
      columnDef: 'a',
      header: 'ਅ',
      cell: (element: SggsConsonantsTableElement) => `${element.a}`,
    },
    {
      columnDef: 'b',
      header: 'ѳਾ',
      cell: (element: SggsConsonantsTableElement) => `${element.b}`,
    },
    {
      columnDef: 'c',
      header: 'ਿ',
      cell: (element: SggsConsonantsTableElement) => `${element.c}`,
    },
    {
      columnDef: 'd',
      header: 'ѳੀ',
      cell: (element: SggsConsonantsTableElement) => `${element.d}`,
    },
    {
      columnDef: 'e',
      header: 'ѳੁ',
      cell: (element: SggsConsonantsTableElement) => `${element.e}`,
    },
    {
      columnDef: 'f',
      header: 'ѳੂ',
      cell: (element: SggsConsonantsTableElement) => `${element.f}`,
    },
    {
      columnDef: 'g',
      header: 'ѳੇ',
      cell: (element: SggsConsonantsTableElement) => `${element.g}`,
    },
    {
      columnDef: 'h',
      header: 'ѳੈ',
      cell: (element: SggsConsonantsTableElement) => `${element.h}`,
    },
    {
      columnDef: 'i',
      header: 'ѳੋ',
      cell: (element: SggsConsonantsTableElement) => `${element.i}`,
    },
    {
      columnDef: 'j',
      header: 'ѳੌ',
      cell: (element: SggsConsonantsTableElement) => `${element.j}`,
    },
  ];
  subscriptsColumns = [
    {
      columnDef: 'subscript',
      header: 'Subscript ',
      cell: (element: SggsSubscriptsTableElement) => `${element.subscript}`,
    },
    {
      columnDef: 'origin',
      header: 'Origin',
      cell: (element: SggsSubscriptsTableElement) => `${element.origin}`,
    },
    {
      columnDef: 'example',
      header: 'example',
      cell: (element: SggsSubscriptsTableElement) => `${element.example}`,
    },
    {
      columnDef: 'transcription',
      header: 'Transcription',
      cell: (element: SggsSubscriptsTableElement) => `${element.transcription}`,
    },
  ];
  cardinalsColumns = [
    {
      columnDef: 'roman',
      header: 'Roman ',
      cell: (element: SggsCardinalsTableElement) => `${element.roman}`,
    },
    {
      columnDef: 'a',
      header: '0',
      cell: (element: SggsCardinalsTableElement) => `${element.a}`,
    },
    {
      columnDef: 'b',
      header: '1',
      cell: (element: SggsCardinalsTableElement) => `${element.b}`,
    },
    {
      columnDef: 'c',
      header: '2',
      cell: (element: SggsCardinalsTableElement) => `${element.c}`,
    },
    {
      columnDef: 'd',
      header: '3',
      cell: (element: SggsCardinalsTableElement) => `${element.d}`,
    },
    {
      columnDef: 'e',
      header: '4',
      cell: (element: SggsCardinalsTableElement) => `${element.e}`,
    },
    {
      columnDef: 'f',
      header: '5',
      cell: (element: SggsCardinalsTableElement) => `${element.f}`,
    },
    {
      columnDef: 'g',
      header: '6',
      cell: (element: SggsCardinalsTableElement) => `${element.g}`,
    },
    {
      columnDef: 'h',
      header: '7',
      cell: (element: SggsCardinalsTableElement) => `${element.h}`,
    },
  ];
  dataSource = ELEMENT_DATA;
  dataSourceConsonants = CONSONANTS_ELEMENT_DATA;
  subscriptsDataSource = SUBSCRIPTS_ELEMENT_DATA;
  cardinalsDataSource = CARDINALS_ELEMENT_DATA;
  displayedColumns = this.columns.map((c) => c.columnDef);
  displayedConsonantsColumns = this.consonantsColumns.map((c) => c.columnDef);
  displayedSubscriptsColumns = this.subscriptsColumns.map((c) => c.columnDef);
  displayedCardinalsColumns = this.cardinalsColumns.map((c) => c.columnDef);

  constructor() {}

  ngOnInit(): void {}

  isHandsetPortraitStatus(status: boolean): void {
    this.isHandsetPortrait = status;
  }

  checkRow(row: any) {}
}
